import { essGet, essPost, hrmsGet } from "../api/api";
import sessionDB from "../utils/sessionDB";

/**
 * The shared request helpers in ../api/api return the full parsed response
 * body (e.g. { data, message, ... }). The attendance UI/components expect
 * just the `data` payload (this mirrors the previous local safeParse()
 * behavior), so we unwrap it here rather than changing every call site.
 */
function unwrapData(response) {
  return response && response.data !== undefined ? response.data : response;
}

/** GET /org/settings/Location_Access_Token?tenantId=... */
export async function getLocationAccessToken() {
  const tenantId = sessionDB.getTenantId();
  const response = await hrmsGet(`/org/settings/Location_Access_Token?tenantId=${tenantId}`);
  return unwrapData(response);
}

/** POST /attendence/get-report — X-Service-Code: ESS05S */
export async function getReport(startDate, endDate) {
  const response = await essPost(
    "/attendence/get-report",
    { startDate, endDate, reportType: "Self", forEmpId: "" },
    "ESS05S"
  );
  return unwrapData(response);
}

/** POST /attendence/get-report — X-Service-Code: ESS05R */
export async function getTeamReport(startDate, endDate, forEmpId = "") {
  const response = await essPost(
    "/attendence/get-report",
    { startDate, endDate, reportType: "Team", forEmpId: forEmpId || "" },
    "ESS05R"
  );
  return unwrapData(response);
}

/**
 * GET /attendence/get-detailed-report/{attendanceId} — X-Service-Code: ESS05R
 * NOTE: endpoint path/method here is a best guess following the same
 * pattern as the other calls in this file. Confirm the actual route +
 * request shape with your backend and adjust if it differs.
 */
export async function getDetailedReport(attendanceId) {
  const response = await essGet(`/attendence/get-detailed-report/${attendanceId}`, "ESS05R");
  return unwrapData(response);
}

/** POST /attendence/check-in — X-Service-Code: ESS05A */
export async function checkIn(payload) {
  const response = await essPost(
    "/attendence/check-in",
    {
      location: payload.location,
      latitude: payload.latitude,
      longitude: payload.longitude,
      geoLocation: payload.geoLocation,
    },
    "ESS05A"
  );
  return unwrapData(response);
}

/** POST /attendence/check-out — X-Service-Code: ESS05O */
export async function checkOut(payload) {
  const response = await essPost(
    "/attendence/check-out",
    {
      attendanceId: payload.attendanceId,
      location: payload.location,
      latitude: payload.latitude,
      longitude: payload.longitude,
      geoLocation: payload.geoLocation,
      activitiesCompleted: payload.activitiesCompleted,
      tomorrowPlan: payload.tomorrowPlan,
    },
    "ESS05O"
  );
  return unwrapData(response);
}

/** POST /attendence/intermediate-entry — X-Service-Code: ESS05I */
export async function intermediateEntry(payload) {
  const response = await essPost(
    "/attendence/intermediate-entry",
    {
      attendanceId: payload.attendanceId,
      location: payload.location,
      latitude: payload.latitude,
      longitude: payload.longitude,
      geoLocation: payload.geoLocation,
    },
    "ESS05I"
  );
  return unwrapData(response);
}

/** POST /attendence/intermediate-exit — X-Service-Code: ESS05X */
export async function intermediateExit(payload) {
  const response = await essPost(
    "/attendence/intermediate-exit",
    {
      attendanceId: payload.attendanceId,
      location: payload.location,
      latitude: payload.latitude,
      longitude: payload.longitude,
      geoLocation: payload.geoLocation,
      reason: payload.reason,
    },
    "ESS05X"
  );
  return unwrapData(response);
}

/** POST /attendence/regularization — X-Service-Code: ESS05R */
export async function regularize(payload) {
  const response = await essPost(
    "/attendence/regularization/apply",
    {
      attendanceId: payload.attendanceId,
      attendanceDate: payload.date,
      requestedCheckInTime: payload.requestedCheckInTime || null,
      requestedCheckOutTime: payload.requestedCheckOutTime || null,
      reason: payload.reason,
    },
    "ESS05R"
  );
  return unwrapData(response);
}

export async function getRegularizationReport(attendanceId) {
  const response = await essGet(
    `/attendence/regularization/get-report/${Number(attendanceId)}`,

    "ESS05S"
  );
  return unwrapData(response);
}


export async function approveRegularization(payload) {
  const response = await essPost(
    "/attendence/regularization/approve",
    {
      regularizationId: payload.regularizationId,
      attendanceId: payload.attendanceId,
      reason: payload.reason,
      status: payload.status, // "Approved" | "Rejected"
    },
    "ESS05R"
  );
  return unwrapData(response);
}